import { RootState } from '@src/state/types'
import { createSelector } from 'reselect'
import { UpsellVariation } from './types'

export const featureFlagsSelector = (state: RootState) => state.featureFlags

export const isDemoActiveSelector = createSelector(
  [featureFlagsSelector],
  featureFlags => !!featureFlags.demoActive
)

export const isOptimizelyClientReadySelector = createSelector(
  [featureFlagsSelector],
  featureFlags => !!featureFlags.clientReady
)

export const cspUpsellFreeTrialSelector = createSelector(
  [featureFlagsSelector],
  ({ cspUpsell }) => !!cspUpsell?.cspUpsellWithFreeTrial
)

export const cspUpsellInterstitialSelector = createSelector(
  [featureFlagsSelector],
  ({ cspUpsell }) => !!cspUpsell?.cspUpsellShowInterstitial
)

export const getUpsellVariation = createSelector(
  [featureFlagsSelector],
  ({ cspUpsell }): UpsellVariation => {
    // control (True, False)
    if (!cspUpsell?.isEnabled) {
      return UpsellVariation.control
    }
    // variation 1 (False, False)
    if (!cspUpsell?.cspUpsellWithFreeTrial && !cspUpsell.cspUpsellShowInterstitial) {
      return UpsellVariation.var1
    }
    // variation 2 (True, True)
    if (cspUpsell.cspUpsellWithFreeTrial && cspUpsell.cspUpsellShowInterstitial) {
      return UpsellVariation.var2
    }
    // variation 3 (False, True)
    if (!cspUpsell.cspUpsellWithFreeTrial && cspUpsell.cspUpsellShowInterstitial) {
      return UpsellVariation.var3
    }
    return UpsellVariation.control
  }
)

export const authModalExpFlagSelector = createSelector(
  [featureFlagsSelector],
  featureFlags => !!featureFlags?.authModalExpFlag
)

export const selectDisablePartialPlagiarismCheck = (state: RootState): boolean =>
  !!state.featureFlags.paritalPlagCheckDisabled



// WEBPACK FOOTER //
// ./src/state/featureFlags/selectors.ts